import type { ReactNode } from "react";
import "./SortableTableHeader.css";

type Props<T extends string> = {
  label?: string;
  children?: ReactNode;
  column: T;
  sortBy: T;
  sortDir: "asc" | "desc";
  onSort: (column: T) => void;
  thClassName?: string;
};

export function SortableTableHeader<T extends string>({
  label,
  children,
  column,
  sortBy,
  sortDir,
  onSort,
  thClassName = "",
}: Props<T>) {
  const active = sortBy === column;
  return (
    <th scope="col" className={thClassName || undefined}>
      <button
        type="button"
        className={`kp-table-sort${active ? " kp-table-sort--active" : ""}`}
        onClick={() => onSort(column)}
        aria-sort={active ? (sortDir === "asc" ? "ascending" : "descending") : "none"}
      >
        {children ?? label}
        <span className="kp-table-sort__icon" aria-hidden>
          {active ? (sortDir === "asc" ? "▲" : "▼") : "↕"}
        </span>
      </button>
    </th>
  );
}
